<form class="two-columns" [formGroup]="featureForm" (ngSubmit)="onSubmit(featureForm)"
    (keydown.enter)="$event.stopPropagation()">
    <div *ngIf="organisationService.activeOrganisation">
        <!----------------------------------------------------------------------------->
        <h1>Merkmal anlegen</h1>
        <!----------------------------------------------------------------------------->
        <mat-form-field>
            <input [value]="
                    organisationService.activeOrganisation.organisationName
                " matInput placeholder="Organisation" disabled />
        </mat-form-field>
        <!----------------------------------------------------------------------------->
        <mat-form-field>
            <input matInput formControlName="featureName" placeholder="Name des Merkmals" required [maxLength]="255" />
        </mat-form-field>
        <!----------------------------------------------------------------------------->
        <div>
            <!------------------------------------------------------------------->
            <mat-form-field>
                <textarea matInput rows="3" formControlName="description" placeholder="Beschreibung des Merkmals"
                    [maxLength]="3000"></textarea>
            </mat-form-field>
            <!------------------------------------------------------------------->
            <div *ngIf="featureForm.value.description != null" class="description-info-message">
                Aktuelle Zeichenlänge
                {{ featureForm.value.description.length }} (Max: 3000)
            </div>
            <!------------------------------------------------------------------->
        </div>
        <!----------------------------------------------------------------------------->
        <div class="columns-50-50">
            <!------------------------------------------------------------------->
            <button mat-raised-button type="submit" class="btn_green">
                Speichern
            </button>
            <!------------------------------------------------------------------->
            <button mat-raised-button type="button" class="btn_red" (click)="cancel()">
                Abbrechen
            </button>
            <!------------------------------------------------------------------->
        </div>
        <!----------------------------------------------------------------------------->
    </div>
</form>